<template>
  <div id="contactInformation">
    <v-container>
      <v-layout wrap class="mb-3">
        <v-flex :class="{'subheading' : $vuetify.breakpoint.mdAndUp}" class="pr-4 ml-4 pf-text-default">
          <p>Please request only if you want to add below items and you're not able to see them in your menu bar</p>
          <ul>
            <li>Photos</li>
            <li>Videos</li>
            <li>Letters</li>
            <li>Blogs</li>
            <li>or Any other area</li>
          </ul>
        </v-flex>
      </v-layout>
      <v-layout wrap class="pr-4 pl-4">
        <p v-if="!!pendingRequest" class="pf-text-pink">Your request to add more data is under review. Please check back soon.</p>
        <p v-else-if="!!approvedRequest" class="pf-text-teal">Your request to add more data was approved. Please add your contents and request back to enable your adoption profile.</p>
        <p v-else-if="!!approvalRequest" class="pf-text-pink">Your request to enable your profile is under review. Please check back soon.</p>
        <v-flex xs12 class="button-container mt-2">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-save" @click="submitRequest" :disabled="!!pendingRequest || !!approvalRequest">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Request</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/* global session store */
import { create, getCollection, update } from '../helpers/helpers';
import swal from 'sweetalert2';
export default {
  name: 'requestAddMoreData',
  props: {

  },
  data: () => ({
    pendingRequest: null,
    approvedRequest: null,
    approvalRequest: null
  }),
  computed: {
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    await this.getPendingRequest();
  },
  methods: {
    async getPendingRequest () {
      if (this.Account.id) {
        let where = { account: this.Account.id, type: 'EnableMenuBack', status: { '$ne': 'Rejected' }};
        let { error, data } = await getCollection('DataUpdateRequest', true, 0, '', where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the request data'
          };
        } else if (data && data.length) {
          /* Rest all */
          this.pendingRequest = null;
          this.approvalRequest = null;
          this.approvedRequest = null;

          let pendingIndex = data.findIndex(x => x.status === 'Pending');
          if (pendingIndex > -1) {
            this.pendingRequest = data[pendingIndex];
          }
          let approvalIndex = data.findIndex(x => x.status === 'Approval');
          if (approvalIndex > -1) {
            this.approvalRequest = data[approvalIndex];
          }
          let approvedIndex = data.findIndex(x => x.status === 'Approved');
          if (approvedIndex > -1) {
            this.approvedRequest = data[approvedIndex];
          }
        }
      }
    },
    async submitRequest () {
      swal.fire({
        title: 'Are you sure?',
        text: 'This will update your profile status',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, continue!'
      }).then(result => {
        if (result.value) {
          (async () => {
            let familyAgency = this.Account.default_agency ? this.Account.default_agency : (this.Account.agency && this.Account.agency.length ? this.Account.agency[0].agency : null);
            if (!familyAgency) {
              swal.fire({
                type: 'warning',
                title: 'No default agency',
                text: 'Please set a default agency for your profile to submit the request.',
                showConfirmButton: true,
                timer: 2500,
                onClose: () => {
                  return;
                }
              });
              return;
            }
            let error = null;
            let data = null;
            if (!this.pendingRequest && !this.approvedRequest && !this.approvalRequest) {
              let requestPayload = {
                account: this.Account.id,
                agency: familyAgency,
                type: 'EnableMenuBack'
              };
              let createResponse = await create('DataUpdateRequest', requestPayload);
              error = createResponse.error;
              data = createResponse.data;

            } else if (this.approvedRequest) {
              this.approvedRequest.status = 'Approval';
              this.approvedRequest.update_from = 'status';
              let updateResponse = await update('DataUpdateRequest', this.approvedRequest, this.approvedRequest.id);
              error = updateResponse.error;
              data = updateResponse.data;
            }
            if (error) {
              console.log('error', error);
              this.snackbar = {
                show: true,
                color: 'red',
                text: `Failed to submit the request, ${error}`
              };
            } else {
              swal.fire({
                type: 'success',
                title: 'Your request was submitted for review, please check back soon.',
                showConfirmButton: false,
                timer: 2500,
                onClose: async () => {
                  await this.getPendingRequest();
                }
              });
            }
          })();
        }
      });
    },
  },

};
</script>

<style lang="css" scoped>
#contactInformation >>> .v-icon.material-icons.accent--text {
  color: #019d8c !important;
  caret-color:  #019d8c !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/RequestAddMoreData.vue